export function assert(condition: any, msg?: string): asserts condition {
  if (!condition) {
    throw new AssertionError(msg);
  }
}

export class AssertionError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, AssertionError.prototype);
  }
}
